import * as React from 'react'
// styles
import './styles.css'
// components
import OurClientsCarousel from './components/OurClientsCarousel'

const OurClientsComponent = () => {
  return (
    <section className='clients-section'>
      <div className='box'>
        <div className='clients-content'>
          <OurClientsCarousel />
        </div>
      </div>
    </section>
  )
}

export default OurClientsComponent
